import { render, staticRenderFns } from "./AdminEmbroideredStripsEditScreen.vue?vue&type=template&id=b37e022e&scoped=true&"
import script from "./AdminEmbroideredStripsEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminEmbroideredStripsEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37e022e",
  null
  
)

export default component.exports